<template>
  <div class="tab_box">
    <div class="header">
      <van-tabs type="card" v-model="active" color="#36B374" class="tab">
        <van-tab title="一类地区">
          <list
            v-if="titleList.length>0"
            :cellWidth="cellWidth"
            :locationList="locationList"
            :locationLevel="locationLevel"
            :titleList="titleList"
            :contentData="contentData"
          />
        </van-tab>
        <van-tab title="二类地区">
          <list
            v-if="titleList.length>0"
            :cellWidth="cellWidth"
            :locationList="locationListTwo"
            :locationLevel="locationLevel"
            :titleList="titleList"
            :contentData="contentDataTwo"
          />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import List from "../components/list";
import api from "@/service/modules/appraiseNew.js";
export default {
  components: {
    List
  },
  data() {
    return {
      active: '0',
      locationLevel: "州市",
      locationList: [],
      locationListTwo: [],
      titleList: [],
      contentDataTwo: [],
      contentData: [],
      cellWidth:
        this.$route.query.type === "I" || this.$route.query.type === "H"
          ? 120
          : 80
    };
  },
  created() {
    // let type = this.$route.query.type;
    // if (type === "B1") {
    //     this.initTitle('投诉5分钟内未响应情况');
    //   } else if (type === "B2") {
    //     this.initTitle('投诉超过24小时未办结情况');
    //   } else if (type === "B3") {
    //     this.initTitle('投诉办结率24小时未达95%');
    //   } else if (type === "G") {
    //     this.initTitle('游客投诉率各州市情况');
    //   } else if (type === "H") {
    //     this.initTitle('游客投诉处置效率各州市情况');
    //   } else if (type === "I") {
    //     this.initTitle('游客投诉处置满意度各州市情况');
    //   } else if (type === "J") {
    //     this.initTitle('游客体验满意度各州市情况');
    //   }
    // this.queryList();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log('to=============-----',from)
      // 通过 `vm` 访问组件实例
      if (from.path === "/appraise/batchReview") {
        vm.active = 0
        console.log('----我要执行')
        let type = vm.$route.query.type;
        if (type === "B1") {
          vm.initTitle('投诉5分钟内未响应情况');
        } else if (type === "B2") {
          vm.initTitle('投诉超过24小时未办结情况');
        } else if (type === "B3") {
          vm.initTitle('投诉办结率24小时未达95%');
        } else if (type === "G") {
          vm.initTitle('游客投诉率各州市情况');
        } else if (type === "H") {
          vm.initTitle('游客投诉处置效率各州市情况');
        } else if (type === "I") {
          vm.initTitle('游客投诉处置满意度各州市情况');
        } else if (type === "J") {
          vm.initTitle('游客体验满意度各州市情况');
        }
        vm.queryList();
      } else {

      }
    });
  },
  methods: {
    initTitle(title) {
      window.yyn.invokeJSB(
      'setTitle',
      {
        title
      },
      cb => {
        console.log('设置title成功：', title);
      }
    );
    },
    queryList() {
      let params = {
        year: this.$route.query.year,
        quarter: this.$route.query.quarter,
        area: this.$route.query.area
      };
      let type = this.$route.query.type;
      if (type === "B1") {
        this.findAllBy5minutes(params);
      } else if (type === "B2") {
        this.findAllBy24hourOutstanding(params);
      } else if (type === "B3") {
        this.findAllBy95Outstanding(params);
      } else if (type === "G") {
        this.findAllTouristComplainRate(params);
      } else if (type === "H") {
        this.findAllComplainDoneRate(params);
      } else if (type === "I") {
        this.findAllComplainDoneSatisfy(params);
      } else if (type === "J") {
        this.findAllTouristExpSatisfy(params);
      }
    },
    // 投诉5分钟内未响应情况
    findAllBy5minutes(params) {
      api.findAllBy5minutes(params).then(res => {
        if (res.ret === 0) {
          this.locationList = res.data.oneAreaTypeResVO;
          this.locationListTwo = res.data.twoAreaTypeResVO;
          this.contentData = [];
          this.contentDataTwo = [];
          this.titleList = ["5分种未响应", "考评扣分", "是否审核", "操作"];
          res.data.oneAreaTypeResVO.forEach(item => {
            this.contentData.push({
              x1: item.respoutNum,
              x2: parseInt(item.deduction) / 100,
              x3: item.audited == "0" ? "否" : "是"
            });
          });
          res.data.twoAreaTypeResVO.forEach(item => {
            this.contentDataTwo.push({
              x1: item.respoutNum,
              x2: parseInt(item.deduction) / 100,
              x3: item.audited == "0" ? "否" : "是"
            });
          });
        }
      });
    },
    // 投诉超过24小时未办结情况
    findAllBy24hourOutstanding(params) {
      api.findAllBy24hourOutstanding(params).then(res => {
        if (res.ret === 0) {
          this.locationList = res.data.oneAreaTypeResVO;
          this.locationListTwo = res.data.twoAreaTypeResVO;
          this.contentData = [];
          this.contentDataTwo = [];
          this.titleList = ["24小时未办结", "考评扣分", "是否审核", "操作"];
          res.data.oneAreaTypeResVO.forEach(item => {
            this.contentData.push({
              x1: item.doneoutNum,
              x2: parseInt(item.deduction) / 100,
              x3: item.audited == "0" ? "否" : "是"
            });
          });
          res.data.twoAreaTypeResVO.forEach(item => {
            this.contentDataTwo.push({
              x1: item.doneoutNum,
              x2: parseInt(item.deduction) / 100,
              x3: item.audited == "0" ? "否" : "是"
            });
          });
        }
      });
    },
    // 投诉办结率24小时未达95
    findAllBy95Outstanding(params) {
      api.findAllBy95Outstanding(params).then(res => {
        if (res.ret === 0) {
          this.locationList = res.data.oneAreaTypeResVO;
          this.locationListTwo = res.data.twoAreaTypeResVO;
          this.contentData = [];
          this.contentDataTwo = [];
          this.titleList = [
            "24小时未办结",
            "投诉件总数",
            "办结率",
            "考评扣分",
            "是否审核",
            "操作"
          ];
          res.data.oneAreaTypeResVO.forEach(item => {
            this.contentData.push({
              x1: item.doneoutNum,
              x2: item.doneNum,
              x3: item.doneinRate/100+'%',
              x4: parseInt(item.deduction) / 100,
              x5: item.audited == "0" ? "否" : "是"
            });
          });
          res.data.twoAreaTypeResVO.forEach(item => {
            this.contentDataTwo.push({
              x1: item.doneoutNum,
              x2: item.doneNum,
              x3: item.doneinRate,
              x4: parseInt(item.deduction) / 100,
              x5: item.audited == "0" ? "否" : "是"
            });
          });
        }
      });
    },
    // 游客投诉率列表数据
    findAllTouristComplainRate(params) {
      api.findAllTouristComplainRate(params).then(res => {
        if (res.ret === 0) {
          this.locationList = res.data.oneAreaTypeResVO;
          this.locationListTwo = res.data.twoAreaTypeResVO;
          this.contentData = [];
          this.contentDataTwo = [];
          this.titleList = [
            "投诉量",
            "接待人次",
            "万人投诉率",
            "考评扣分",
            "是否审核",
            "操作"
          ];
          res.data.oneAreaTypeResVO.forEach(item => {
            this.contentData.push({
              x1: item.complainNum,
              x2: item.touristNumCN,
              x3: item.complainRate/100+'%',
              x4: parseInt(item.deduction) / 100,
              x5: item.audited == "0" ? "否" : "是"
            });
          });
          res.data.twoAreaTypeResVO.forEach(item => {
            this.contentDataTwo.push({
              x1: item.complainNum,
              x2: item.touristNumCN,
              x3: item.complainRate/100+'%',
              x4: parseInt(item.deduction) / 100,
              x5: item.audited == "0" ? "否" : "是"
            });
          });
        }
      });
    },
    // 游客投诉处置效率列表数据
    findAllComplainDoneRate(params) {
      api.findAllComplainDoneRate(params).then(res => {
        if (res.ret === 0) {
          this.locationList = res.data.oneAreaTypeResVO;
          this.locationListTwo = res.data.twoAreaTypeResVO;
          this.contentData = [];
          this.contentDataTwo = [];
          this.titleList = [
            "投诉量",
            "平均办结时长",
            "考评扣分",
            "是否审核",
            "操作"
          ];
          res.data.oneAreaTypeResVO.forEach(item => {
            this.contentData.push({
              x1: item.complainNum,
              x2: item.donetimeAvgCN,
              x3: parseInt(item.deduction) / 100,
              x4: item.audited == "0" ? "否" : "是"
            });
          });
          res.data.twoAreaTypeResVO.forEach(item => {
            this.contentDataTwo.push({
              x1: item.complainNum,
              x2: item.donetimeAvgCN,
              x3: parseInt(item.deduction) / 100,
              x4: item.audited == "0" ? "否" : "是"
            });
          });
        }
      });
    },
    // 游客投诉处置满意度列表数据
    findAllComplainDoneSatisfy(params) {
      api.findAllComplainDoneSatisfy(params).then(res => {
        if (res.ret === 0) {
          this.locationList = res.data.oneAreaTypeResVO;
          this.locationListTwo = res.data.twoAreaTypeResVO;
          this.contentData = [];
          this.contentDataTwo = [];
          this.titleList = [
            "投诉量",
            "游客满意度投诉量",
            "游客基本满意投诉量",
            "游客不满意度投诉量	",
            "游客未评价投诉量",
            "考评扣分",
            "是否审核",
            "操作"
          ];
          res.data.oneAreaTypeResVO.forEach(item => {
            this.contentData.push({
              x1: item.complainNum,
              x2: item.satisfyingNum,
              x3: item.satisfiedNum,
              x4: item.ilsatisfyNum,
              x5: item.miEvaluateNum,
              x6: parseInt(item.deduction) / 100,
              x7: item.audited == "0" ? "否" : "是"
            });
          });
          res.data.twoAreaTypeResVO.forEach(item => {
            this.contentDataTwo.push({
              x1: item.complainNum,
              x2: item.satisfyingNum,
              x3: item.satisfiedNum,
              x4: item.ilsatisfyNum,
              x5: item.miEvaluateNum,
              x6: parseInt(item.deduction) / 100,
              x7: item.audited == "0" ? "否" : "是"
            });
          });
        }
      });
    },
    // 游客体验满意度列表数据
    findAllTouristExpSatisfy(params) {
      api.findAllTouristExpSatisfy(params).then(res => {
        if (res.ret === 0) {
          this.locationList = res.data.oneAreaTypeResVO;
          this.locationListTwo = res.data.twoAreaTypeResVO;
          this.contentData = [];
          this.contentDataTwo = [];
          this.titleList = ["问卷量", "考评扣分", "是否审核"];
          res.data.oneAreaTypeResVO.forEach(item => {
            this.contentData.push({
              x1: item.questionnaireNum,
              x2: parseInt(item.expSatisfyScore) / 100,
              x3: item.audited == "0" ? "否" : "是"
            });
          });
          res.data.twoAreaTypeResVO.forEach(item => {
            this.contentDataTwo.push({
              x1: item.questionnaireNum,
              x2: parseInt(item.expSatisfyScore) / 100,
              x3: item.audited == "0" ? "否" : "是"
            });
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.tab_box {
  .header {
    margin-top: 25px;
    padding: 0 12px;
  }
  ::v-deep .van-tabs__nav {
    width: 196px;
    height: 30px;
    border-radius: 1px;
    margin: 0px;
  }
  ::v-deep .van-tabs__content {
    margin-top: 12px;
    // width:351px;
    // height:325px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
  }
}
</style>
